<template>
  <section>
    Settings
  </section>
</template>

<script>
export default {
  name: 'Settings',
};
</script>

<style scoped>

</style>
